import { h } from 'preact'
import Router from 'preact-router'
import FirebaseComponent from './FirebaseComponent'
import Navbar from './Navbar'
import Home from './Home'
import SignUp from './SignUp'
import SignIn from './SignIn'
import Planner from './Planner'
import Competencies from './Competencies'
import Travel from './Travel'
import Profile from './Profile'
import Medical from './Medical'
import PrivacyPolicy from './PrivacyPolicy'
import CookiePolicy from './CookiePolicy'
import TermsAndConditions from './TermsAndConditions'
import { NotificationContainer } from 'react-notifications';

import 'react-notifications/lib/notifications.css';

class App extends FirebaseComponent {
  render() {
    return (
      <div class='container'>
        <Navbar/>
        <NotificationContainer/>

        <Router>
          <Home path="/" />
          <SignIn path="/signin" />
          <SignUp path="/signup" />
          <Planner path="/planner" />
          <Competencies path="/competencies" />
          <Travel path="/travel" />
          <Profile path="/profile" />
          <Medical path="/medical" />
          <PrivacyPolicy path="/privacy-policy" />
          <CookiePolicy path="/cookie-policy" />
          <TermsAndConditions path="terms-and-conditions" />
        </Router>

      </div>
    );
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js